// 拓尔思流式接口返回数据示例
// 已连接到 http://ai.trs.cn/agent-demo/agent/stream/impl
// MSG{"type": "log", "value": "开始执行：向量检索"}
// MSG{"type": "log", "value": "向量检索执行完成"}
// MSG{
//     "type": "link",
//     "value": [
//         {
//             "linkId": 1,
//             "docTitle": "最高涨80%！各省电价调整汇总！",
//             "docContent": "据了解，天津电价上浮并不是个例，为落实发改委要求，近期江苏、浙江、山东、广西等多地上调了上网电价，部分地区电价"顶格上浮"(上下浮动范围不超过20%)，内蒙古地区市场交易电价甚至上浮80%，浙江对高耗能用户征收惩罚性电费最高3毛5。实际上，8、9月份就有部分地区出台电价改革方案，例如贵州、广东等省份先后发布通知，执行分时电价政策，在平段电价基础上，上、下浮一定比例，形成高峰电价和低谷电价。目前限电最严的地区是河南，目前电炉已全部停产，长流程限产30%;长三角地区电力缺口仍有，但10月电炉厂并未大面积停产，以错峰生产为主。新疆维吾尔自治区发展和改革委员会发布了关于公开征求《关于完善我区分时电价机制有关事项的通知》意见的公告，尖峰时段用电价格在峰段电价基础上每千瓦时上浮20%。"管住中间、放开两头"，10月15日，新一轮电价改革开启。电价改革首日，山东、江苏等地电力市场成交价均较基准价有所上浮，基本触及此轮电价改革要求的上限，浙江、广西等多地也有所动作。日前，广东省发改委印发(粤发改价格[2021)402号)出台，从此，广东电力交易将发生根本变化，所有工商业用电都进入市场了，没有工商业目录电价电价可能涨幅将接近20%!最高涨80%！各省电价调整汇总！山东电力交易中心组织开展了深化煤电上网电价市场化改革后的首次交易，共有49家燃煤发电企业(97台机组)与79家售电公司和5家电力用户参与，成交电量110.7亿千瓦时，成交均价较基准电价上浮19.8%。浙江省发展改革委印发《关于进一步完善我省分时电价政策有关事项的通知》，此次调整延长了用电尖峰时段，并拉大了峰谷分时电价的价差。此次将全年大工业电价尖峰时段由原来的2个小时增加至4小时，每年夏季7、8月份及冬季1、12月份，全天尖峰时段由原来的2个小时增加至6小时，提高大工业尖峰电价每千瓦时5.6分、高峰电价每千瓦时6分。江苏组织开展了10月中旬月内挂牌交易，共成交电量19.98亿千瓦时，成交均价468.97元/兆瓦时，成交价较基准价上浮了19.94%。延长用电尖峰时段，拉大峰谷分时电价价差，对高耗能征收惩罚性电费，最高3毛5",
//             "date": "2021",
//             "url": "http://www.chinapower.com.cn/zhengcefagui/zhengcewenjian/2021-10-25/109718.html",
//             "dbname": "ny_zhengce"
//         },
//         {
//             "linkId": 2,
//             "docTitle": "美国得州大停电是"人祸"，别想让光伏风电背锅！",
//             "docContent": "在供需的极端不平衡下，得州电价疯狂飙升，最高时暴涨近200倍，批发电价突破了每兆瓦时1万美元，相当于每度电65元人民币，一些居民因此收到了供电公司的天价账单，停电的家庭和商户一度超过450万户，并有超过1490万人断水。",
//             "date": "2021",
//             "url": "http://www.chinapower.com.cn/xw/zyxw/20210222/53424.html",
//             "dbname": "ny_zhengce"
//         }
//     ]
// }
// MSG{"type": "log", "value": "输出节点"}
// MSG{"type": "log", "value": "开始思考"}
// MSG{"type": "think", "value": "\n"}
// MSG{"type": "think", "value": "好的"}
// MSG{"type": "think", "value": "，"}
// MSG{"type": "think", "value": "早上好"}
// ......
// MSG{"type": "log", "value": "思考结束"}
// MSG{"type": "llm", "value": "\n\n"}
// MSG{"type": "llm", "value": "根据"}
// MSG{"type": "llm", "value": "提供的"}
// MSG{"type": "llm", "value": "参考"}
// MSG{"type": "llm", "value": "文献"}
// ......
// MSG{"type": "llm", "value": "。"}
// COMPLETE{"type": "complete"}
// 已断开连接 http://ai.trs.cn/agent-demo/agent/stream/impl

// //接口调用方法
// const formData = new FormData()
// formData.append('text', msg.send)  // 发送的文本
// formData.append('sessionId', session_id)  // 会话ID,自己创建，用uuid生成
// formData.append('id', 201)  // 模型ID，固定
// const apiUrl = 'http://ai.trs.cn/agent-demo/agent/stream/impl'

// fetch(apiUrl, {
//     method: 'POST',
//     body: formData,
//     signal: abortController.signal // Add abort signal
// })

import { useEffect, useState, useRef } from 'react';
import ReactMde from "react-mde";
import "react-mde/lib/styles/css/react-mde-all.css";
import * as Showdown from "showdown";
import { ReactComponent as SparkSvg } from '@images/icons/spark.svg';
import { ChevronDown, ChevronUp } from 'react-feather';
import { getPolicyChange } from '../../../../axios/api';

export const PolicyCompareAnalysis = (props) => {
    const { searchK } = props;

    // 状态管理
    const [isLoading, setIsLoading] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const [isThinkExpanded, setIsThinkExpanded] = useState(true);
    const [currentStage, setCurrentStage] = useState('');
    const [thinkContent, setThinkContent] = useState('');
    const [answerContent, setAnswerContent] = useState('');
    const [links, setLinks] = useState([]);
    const [isComplete, setIsComplete] = useState(false);

    // refs
    const abortControllerRef = useRef(null);
    const sessionIdRef = useRef(null);

    // Showdown converter for markdown
    const converter = new Showdown.Converter({
        tables: true,
        simplifiedAutoLink: true,
        strikethrough: true,
        tasklists: true
    });

    // 生成会话ID
    const generateSessionId = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };

    // 重置状态
    const resetState = () => {
        setCurrentStage('');
        setThinkContent('');
        setAnswerContent('');
        setLinks([]);
        setIsComplete(false);
        setIsLoading(false);
    };

    // 处理流式数据
    const handleStreamData = (data) => {
        console.log('收到流式数据:', data); // 添加调试日志
        try {
            const parsed = JSON.parse(data);
            console.log('解析后的数据:', parsed); // 添加调试日志

            switch (parsed.type) {
                case 'log':
                    console.log('处理log:', parsed.value);
                    setCurrentStage(parsed.value);
                    break;

                case 'link':
                    console.log('处理link:', parsed.value);
                    setLinks(parsed.value || []);
                    break;

                case 'think':
                    console.log('处理think:', parsed.value);
                    setThinkContent(prev => prev + parsed.value);
                    break;

                case 'llm':
                    console.log('处理llm:', parsed.value);
                    setAnswerContent(prev => {
                        let newContent = prev + parsed.value;
                        // 处理markdown表格格式
                        if (newContent.includes('|')) {
                            newContent = newContent.replace(/```markdown\|/g, '```markdown\n|');
                            newContent = newContent.replace(/\|\n```/g, '\n```');
                        }
                        if (newContent.includes('```markdown')) {
                            newContent = newContent.replace(/```markdown\n?/g, '');
                            newContent = newContent.replace(/\n?```/g, '');
                        }
                        console.log('更新后的答案内容:', newContent);
                        return newContent;
                    });
                    break;

                case 'complete':
                    console.log('处理complete');
                    setIsComplete(true);
                    setIsLoading(false);
                    setCurrentStage('分析完成');
                    break;

                default:
                    console.log('未知类型:', parsed.type);
                    break;
            }
        } catch (error) {
            console.error('解析流式数据错误:', error, '原始数据:', data);
        }
    };

    // 调用流式接口
    const callStreamAPI = async (searchText) => {
        if (!searchText?.trim()) return;

        console.log('开始调用流式接口，搜索内容:', searchText);
        resetState();
        setIsLoading(true);

        // 中止之前的请求
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        abortControllerRef.current = new AbortController();
        sessionIdRef.current = generateSessionId();

        try {
            // 构建新的请求参数
            const requestData = {
                messages: [
                    {
                        role: "user",
                        content: `"${searchText}"，对这两个政策进行对比，分析比较两者的要点、异同、趋势导向等，如果两个政策之间有变迁、延伸、解读关系，则要对两者内容的演变做出分析。`
                    }
                ],
                stream: true
            };

            // 如果是grid-build环境，添加model字段
            if (process.env.REACT_APP_TYPE === 'grid-build') {
                requestData.model = "DeepSeek-R1-Distill-Llama-70B-fast";
            }

            console.log('发送请求参数:', requestData);

            // 使用流式接口
            await getPolicyChange(requestData, (progress) => {
                handleStreamData(JSON.stringify(progress));
            });

        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('请求被中止');
            } else {
                console.error('流式接口调用错误:', error);
                setCurrentStage('分析失败，请稍后重试');
                setIsLoading(false);
            }
        }
    };

    // 监听搜索关键词变化
    useEffect(() => {
        if (searchK) {
            callStreamAPI(searchK);
        }

        // 清理函数
        return () => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
    }, [searchK]);

    // 获取预览内容（前三行）
    const getPreviewContent = () => {
        if (!answerContent) return '';
        const lines = answerContent.split('\n').filter(line => line.trim());
        return lines.slice(0, 3).join('\n');
    };

    return (
        <div className="w-full bg-base-100 p-8">
            <div className='flex w-full items-center gap-4 mb-6'>
                <div className="flex items-center gap-2">
                    {isLoading ? (
                        <span className="loading loading-spinner loading-md"></span>
                    ) : (
                        <SparkSvg/>
                    )}
                    <div className="card-title">
                        政策分析对比{process.env.REACT_APP_CLIENT_ID === 'client-a' && '(由拓尔思提供支持)'}
                    </div>
                </div>
                {/* 当前阶段显示 */}
                {currentStage && (
                    <div className="">
                        <div className="flex items-center gap-2">
                            {isLoading && (
                                <span className="loading loading-spinner loading-sm"></span>
                            )}
                            <span className="text-sm text-base-content/70">
                                {currentStage}
                            </span>
                        </div>
                    </div>
                )}
            </div>

            {/* 思考内容和答案内容区域 */}
            {(thinkContent || answerContent) && (
                <div className="mb-4">
                    <div className="relative">
                        {/* 预览模式 */}
                        {!isExpanded && (
                            <div className="relative">
                                <div className="max-h-96 overflow-y-auto">
                                    {/* 深度思考内容 */}
                                    {thinkContent && (
                                        <div className="mb-3">
                                            <div
                                                className="flex items-center gap-2 cursor-pointer hover:text-primary transition-colors mb-2"
                                                onClick={() => setIsThinkExpanded(!isThinkExpanded)}
                                            >
                                                <span className="text-sm font-medium">深度思考</span>
                                                {isThinkExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                                            </div>

                                            {isThinkExpanded && (
                                                <div className="p-3 bg-base-200 rounded-lg text-sm">
                                                    <pre className="whitespace-pre-wrap font-sans text-base-content/70">
                                                        {thinkContent}
                                                    </pre>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {/* 答案内容 */}
                                    {answerContent && (
                                        <div>
                                            <ReactMde
                                                selectedTab="preview"
                                                value={getPreviewContent()}
                                                readOnly
                                                generateMarkdownPreview={markdown =>
                                                    Promise.resolve(converter.makeHtml(markdown))
                                                }
                                            />
                                        </div>
                                    )}
                                </div>
                                {/* 渐变遮罩 */}
                                <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-base-100 to-transparent"></div>
                            </div>
                        )}

                        {/* 完整内容模式 */}
                        {isExpanded && (
                            <div className="">
                                {/* 深度思考内容 */}
                                {thinkContent && (
                                    <div className="mb-4">
                                        <div
                                            className="flex items-center gap-2 cursor-pointer hover:text-primary transition-colors mb-2"
                                            onClick={() => setIsThinkExpanded(!isThinkExpanded)}
                                        >
                                            <span className="text-sm font-medium">深度思考</span>
                                            {isThinkExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                                        </div>

                                        {isThinkExpanded && (
                                            <div className="p-3 bg-base-200 rounded-lg text-sm">
                                                <pre className="whitespace-pre-wrap font-sans">
                                                    {thinkContent}
                                                </pre>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* 答案内容 */}
                                {answerContent && (
                                    <div>
                                        <ReactMde
                                            selectedTab="preview"
                                            value={answerContent}
                                            readOnly
                                            generateMarkdownPreview={markdown =>
                                                Promise.resolve(converter.makeHtml(markdown))
                                            }
                                        />
                                    </div>
                                )}
                            </div>
                        )}

                        {/* 展开/折叠按钮 */}
                        <div className="flex justify-center mt-2">
                            <button
                                className="btn btn-sm btn-ghost gap-2"
                                onClick={() => setIsExpanded(!isExpanded)}
                            >
                                {isExpanded ? (
                                    <>
                                        <ChevronUp size={16} />
                                        收起
                                    </>
                                ) : (
                                    <>
                                        <ChevronDown size={16} />
                                        展开全部
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* 无内容提示 */}
            {!isLoading && !answerContent && !currentStage && (
                <div className="text-center text-base-content/50 py-8">
                    <p>请输入搜索关键词以开始政策对比分析</p>
                </div>
            )}
        </div>
    );
};